"use client";

import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { LuArrowUpRight } from "react-icons/lu";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1], delay },
  }),
};

const expandWidth = {
  hidden: { width: 0, opacity: 0.5 },
  visible: {
    width: "100%",
    opacity: 0.5,
    transition: { duration: 0.9, ease: [0.25, 0.1, 0.25, 1], delay: 0.9 },
  },
};

export default function AboutSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section
      ref={ref}
      className="bg-[#1A1A1A] text-white py-10 md:py-20 px-6 md:px-20"
    >
      <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">

        {/* Left Column */}
       {/* Left Column */}
<div className="md:h-full">
  {/* Image between copyright and heading */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    animate={inView ? "visible" : "hidden"}
    custom={0.2}
    className="md:h-full"
  >
    <img
      src="/assets/bgnew.jpg"
      alt="About AJPG"
      className="w-full h-64 md:h-full md:min-h-[24rem] object-cover"
    />
  </motion.div>

</div>

        {/* Right Column */}
        <div className="space-y-4 text-gray-300 max-w-xl text-sm md:text-base lg:text-lg font-sans">
          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.3}
          >
            Welcome to AJP Group,
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.42}
          >
            Our automotive business is based out of the UK and India, being in the automotive service industry for over fifteen year repairing, restoring and upgrading luxury and classic cars.
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.54}
          >
            We operate workshops and breakage facilities in both countries and are active in numerous retro and classic car builds. We offer customers not just a platform to build cars but also procure doner and salvage cars that best suit your dream car build.
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.66}
          >
            We have an employee base of fifty now and over the years continue to grow, recently adding a chemical dipping facility in India that offers a unique and faster solution to get cars rust free and ready for their paintwork.
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.78}
          >
            We’re proud to work with some of the best in the industry and have an extremely loyal customers base for many years now. We work well with those who value our time and workmanship.
          </motion.p>

          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={0.9}
          >
            I look forward to welcoming you at any one of our locations.
          </motion.p>

          <motion.p
            className="pt-2"
            variants={fadeUp}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            custom={1.05}
          >
            Regards,<br />
            Alexander Johnson – Founder & CEO
          </motion.p>

          {/* Gold accent line */}
          <motion.div
            className="h-px bg-[#C9A24D]"
            variants={expandWidth}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
          />

          {/* <button className="inline-flex items-center gap-2 bg-[#C9A24D] text-black px-5 py-2 text-sm font-medium hover:bg-[#b8933f] transition">
            Learn More
            <LuArrowUpRight className="text-lg" />
          </button> */}
        </div>

      </div>
    </section>
  );
}